<div class="custom-progress-container">
  <div class="custom-progress-header">
    <span class="custom-progress-title">{{ title }}</span>
    <span class="custom-progress-info">{{ infoText }}</span>
  </div>

  <div class="custom-progress-track">
    <div
      class="custom-progress-fill"
      [style.width.%]="clampedWidth"
      [class.success]="isSuccess"
      [class.danger]="isDanger"
    ></div>
  </div>
  
  <div class="custom-progress-footer">
    <span [class.text-danger]="isDanger">{{ footerText }}</span>
  </div>
</div>